require('./internalTransferFundStep2.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ components
const { FundLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/fundLegalConfirmation/fundLegalConfirmation');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { API_ENTERPRISE_NUMBER, API_CENTER, FIRST_STEP, SECOND_STEP, BROKER_INTERNAL_TRANSFER_NEW_FUND } = require('constants/index');
const { BROKER_INTERNAL_TRANSFER_FUND_ID, MULTIPLE_OPERATIONS } = require('constants/operationTypes');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const { PRODUCT_TYPE, TRANSFER_ORDER_TYPE } = require('constants/contactCenter/brokerFundsSendEmailConstants');
const { BROKER_DOCUMENT_TYPE, BROKER_ORDER_TYPE_BUY } = require('constants/index');
const { OKMessage } = require('commonsComponents/OKMessage');
const BrokerInternalTransferFundsStep2ExantDetails = require('components/broker/brokerInternalTransferFundsStep2ExantDetails/brokerInternalTransferFundsStep2ExantDetails');

 //@ utilities
const { FormattedText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { getPersonTypeAndCode } = require('utilities/hash');

class InternalTransferFundStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
        this.buildExAntCost = this.buildExAntCost.bind(this);
    }

    componentWillMount() {
        const {
            history,
            immInternalTransferFund,
            immBrokerMyInvestments,
            getMorningStarScreener,
            getPreMotor,
            fundVersionNew
        } = this.props;

        let fundId;

        if( fundVersionNew ) {
            const newDestinationFundId = immInternalTransferFund.getIn(['steps', FIRST_STEP, 'destinationFund']);
            const fundType = immInternalTransferFund.getIn(['steps', FIRST_STEP, 'fundType']);

            if  (fundType === BROKER_INTERNAL_TRANSFER_NEW_FUND) {
                fundId = newDestinationFundId;
            } else {
                const funds = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']);
                const newDestinationFund = funds.find(f => f.get('id') === newDestinationFundId);
                fundId = newDestinationFund.get('customInstitutionSecurityId');
            }


        }
        else {
            const immFunds = immBrokerMyInvestments.getIn([ 'products', 'funds', 'stocks' ]);
            const selectedDestination = immInternalTransferFund.getIn([ 'steps', FIRST_STEP, 'destinationFund' ]);
            fundId = immFunds.getIn([ selectedDestination, 'customInstitutionSecurityId' ]);
        }
        getMorningStarScreener(fundId);
        getPreMotor(history);
    }

    componentWillUnmount() {
        const { resetLegalInformation } = this.props;

        resetLegalInformation();
    }

    handleYesNoOptionChange(value) {
        const { legalYesNoOptionChange } = this.props;

        legalYesNoOptionChange(value);
    }

    getSendEmailParams() {
        const { immProfileFields, immInvestmentFunds } = this.props;

        const clientEmailAddress = PersonalDataHelper.getEmail(immProfileFields);
        const fundIsin = immInvestmentFunds.getIn([ 'steps', FIRST_STEP, 'investmentFunds', 'isin' ]);
        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const nombreCliente = immProfileFields.get('nombreCliente', '');

        return {
            clientAlias: nombreCliente,
            email: clientEmailAddress,
            isin: fundIsin,
            isinDescribe: fundName,
            orderType: TRANSFER_ORDER_TYPE,
            productType: PRODUCT_TYPE
        };
    }

    buildExAntCost() {
        const {
            immFlagBasedFeatures,
            immAccounts,
            immInternalTransferFund,
            immBrokerMyInvestments,
            immFunds,
        } = this.props;

        return immFlagBasedFeatures.get("wealth_funds_transfer_show_costs") ? (
            <div className="internal-transfer-fund-step2__cc-ex-ant-cost-container">
                <BrokerInternalTransferFundsStep2ExantDetails
                    immAccounts={immAccounts}
                    immBrokerInternalTransferFunds={
                        immInternalTransferFund
                    }
                    immBrokerMyInvestments={immBrokerMyInvestments}
                    immFunds={immFunds}
                />
                <div className="internal-transfer-fund-step2__cc-ex-ant-cost-disclaimer">
                    <OKMessage extraClass="internal-transfer-fund-step2__cc-ex-ant-cost-disclaimer">
                        <FormattedText value="brokerInternalTransferFund-exAntCCDisclaimer" />
                    </OKMessage>
                </div>
            </div>
        ) : null;

    }

    buildLegalConfirmation() {
        const {
            immInternalTransferFund,
            immPreContractualMail,
            immProfileFields,
            immInvestmentFunds,
            sendEmail,
            resetEmailState,
            refreshEmailAddress,
            immFlagBasedFeatures,
        } = this.props;
        const selectedYesNoOption = immInternalTransferFund.getIn([ 'steps', SECOND_STEP, 'selectedYesNoOption' ]);
        const sendEmailParams = this.getSendEmailParams();

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId']);
        const exAntCost = this.buildExAntCost();
        if (fundName && fundIsin && fundSecId) {
            return (
                <FundLegalConfirmation
                    className="internal-transfer-fund-step2__legal-confirmation no-print-out"
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    fundName={fundName}
                    immProfileFields={immProfileFields}
                    immPreContractualMail={immPreContractualMail}
                    sendMail={sendEmail}
                    sendMailParams={sendEmailParams}
                    resetMailState={resetEmailState}
                    selectedYesNoOption={selectedYesNoOption}
                    requestProfile={refreshEmailAddress}
                    onYesNoOptionChange={this.handleYesNoOptionChange}
                    costDocumentType={BROKER_DOCUMENT_TYPE}
                    costOrderType={BROKER_ORDER_TYPE_BUY}
                    exAntCost={exAntCost}
                    withoutCostDocument={immFlagBasedFeatures.get("wealth_funds_transfer_show_costs")}
                />
            );
        } else {
            return <LoadingSection/>;
        }
    }

    buildConfirmationError() {
        const { immInternalTransferFund } = this.props;

        const yesNoOptionInvalid = immInternalTransferFund.getIn([ 'steps', SECOND_STEP, 'yesNoOptionInvalid' ]);
        const mailInvalid = immInternalTransferFund.getIn([ 'steps', SECOND_STEP, 'mailInvalid' ]);

        if (mailInvalid) {
            return (
                <FormattedText
                    value="brokerInternalTransferFund-confirmationErrorMailInvalid"
                    className="internal-transfer-fund-step2__confirmation-error no-print-out"
                />
            );
        }

        if (yesNoOptionInvalid) {
            return (
                <FormattedText
                    value="brokerInternalTransferFund-confirmationErrorYesNoOptionInvalid"
                    className="internal-transfer-fund-step2__confirmation-error no-print-out"
                />
            );
        }

        return null;
    }

    buildSignaturePattern() {
        const { immInternalTransferFund, immBrokerMyInvestments } = this.props;

        const selectedYesNoOption = immInternalTransferFund.getIn([ 'steps', SECOND_STEP, 'selectedYesNoOption' ]);
        const originFund = immInternalTransferFund.getIn([ 'steps', FIRST_STEP, 'originFund' ]);
        const funds = immBrokerMyInvestments.getIn([ 'products', 'funds', 'stocks' ]);
        const selectedOrigin = funds.find(fund => fund.get('id') === originFund);
        const destinationFundId  = immInternalTransferFund.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const selectedDestinationFund = funds.find(x => x.get('id') === destinationFundId);
        const immSteps = immInternalTransferFund.get('steps');
        const isTotalTransfer = immSteps.getIn([FIRST_STEP, 'type']) === 'total';
        const originHasContribution = immInternalTransferFund.getIn(['steps', FIRST_STEP, 'originHasContribution']);
        const destinationHasContribution = immInternalTransferFund.getIn(['steps', FIRST_STEP, 'destinationHasContribution']);
        const onlyOriginContribution = originHasContribution && !destinationHasContribution;

        let operationParams = {
            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${selectedOrigin.get('product')}${selectedOrigin.get('numerodecontrato')}`,
        };
        let operationType = BROKER_INTERNAL_TRANSFER_FUND_ID;
        
        const userData = getPersonTypeAndCode();
        const idUser = userData.f;
        const documentTypeUser = userData.type;
        const isContributionStepSkipped = immInternalTransferFund.get('skipContributionStep')


        if (onlyOriginContribution && !isContributionStepSkipped && isTotalTransfer) {
            operationType = MULTIPLE_OPERATIONS;
            operationParams = {
                requestMulti: [
                    {
                        serviceCode: BROKER_INTERNAL_TRANSFER_FUND_ID,
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${selectedOrigin.get('product')}${selectedOrigin.get('numerodecontrato')}`
                    },
                    {
                        serviceCode: 202,
                        ammount: `+${immInternalTransferFund.getIn(['steps', 1, 'amount'])}`,
                        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                        clientId: `${idUser}`,
                        clientType: documentTypeUser,
                        currency: immInternalTransferFund.getIn(['steps', 1, 'customMinimumPurchaseAmount', 'currency']),
                        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${selectedDestinationFund.get('product')}${selectedDestinationFund.get('numerodecontrato')}`
                    },
                ]
            };
        }

        const signaturePatternClassName = classNames('internal-transfer-fund-step2__signature-pattern', {
            'internal-transfer-fund-step2__signature-pattern--disabled': selectedYesNoOption !== SELECTED_VALUES.YES
        });

        return (
            <div className="internal-transfer-fund-step2__security-challenge">
                <FormattedText className="internal-transfer-fund-step2__security-challenge-title" value="brokerInternalTransferFund-securityChallengeTitle" />
                <div className={signaturePatternClassName}>
                    <SignaturePattern
                        operationType={operationType}
                        operationParams={operationParams}
                        disabled={selectedYesNoOption !== SELECTED_VALUES.YES}
                        isInVerticalWizard={true}
                    />
                </div>
            </div>
        );
    }

    render() {
        const legalConfirmation = this.buildLegalConfirmation();
        const confirmationError = this.buildConfirmationError();
        const signaturePattern = this.buildSignaturePattern();

        const printerHiddenSection = (
            <div className="printer-preview__normal-hidden-content">
                {this.props.children}
            </div>
        );

        return (
            <div className="internal-transfer-fund-step2">
                {printerHiddenSection}
                {legalConfirmation}
                {signaturePattern}
                {confirmationError}
            </div>
        );
    }
}

InternalTransferFundStep2.propTypes = {
    history: PropTypes.object.isRequired,
    immInternalTransferFund: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getPreMotor: PropTypes.func.isRequired,
    getMorningStarScreener: PropTypes.func.isRequired,
    legalYesNoOptionChange: PropTypes.func.isRequired,
    resetLegalInformation: PropTypes.func.isRequired,
    sendEmail: PropTypes.func.isRequired,
    resetEmailState: PropTypes.func.isRequired,
    refreshEmailAddress: PropTypes.func.isRequired,
    fundVersionNew: PropTypes.bool,
    children: PropTypes.any,
    immAccounts: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
};

InternalTransferFundStep2.defaultProps = {
    fundVersionNew: false
}

module.exports = withRouter(InternalTransferFundStep2);
